<template>
    <div class="show-top-grids">
        <div class="col-sm-8 single-left">
            <div class="song">
                <!--<div class="song-info">-->
                    <!--<h3>{{ videoData.title }}</h3>-->
                <!--</div>-->
                <div class="embed-responsive embed-responsive-16by9">
                    <iframe class="embed-responsive-item" :src="videoData.player" allowfullscreen></iframe>
                </div>
            </div>
            <!--分享-->
            <!--<layoutShare :shareUrl="this.nowUrl" :videoData="videoData" :embedCode="embedCode" :videoCounter="videoData.counter" :videoCounterView="videoData.videoCounterView" :type="'vod'" :num="'0'"></layoutShare>-->

            <div class="clearfix"></div>
            <div class="published">
                <div class="load_more">
                    <ul id="myList">
                        <li>
                            <h4>{{ videoData.title }}<br>發佈日期：{{ videoData.publish_time }}</h4>
                            <!--<h4>{{ videoData.videoKeyword }}</h4>-->
                            <p v-html="videoData.content"></p>
                        </li>
                    </ul>
                </div>
            </div>

        </div>

        <div class="col-md-4 single-right">
            <h3>相關影音</h3>
            <div class="single-grid-right">
                <router-link :to="{ name: 'VideoWatch', params: { vid: data.vid } }" v-for="(data, index) in videosRelated" :key="index">
                    <div class="single-right-grids">
                        <div class="col-md-4 single-right-grid-left">
                            <div class="zoomImage" :style="'background-image:url('+data.thumbnail+')'"></div>
                        </div>
                        <div class="col-md-8 single-right-grid-right">
                            <router-link :to="{ name: 'VideoWatch', params: { vid: data.vid } }" class="title">{{ data.title }}</router-link>
                            <p class="author">
                                <!--<router-link v-if="(data.ownerType=='C')" :to="{name: 'CommitteeDetail', params: { gid: data.owner_group}}" class="author">{{ data.ownerName }}</router-link>-->
                                <!--<router-link v-else :to="{path: '/member/'+data.owner_group}" class="author">{{ data.ownerName }}</router-link>-->
<!--                                <a href="javascript:void(0);" class="author" style="cursor:text;">CmsDemo</a>-->
                            </p>
                            <p class="views">{{ data.publish_time }}</p>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </router-link>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
</template>

<script>

export default {
  name: '',
  data () {
    return {
      videoData: [],
      videosRelated: [],
      routePath: [],
      embedCode: '',
      nowUrl: window.location.href
    }
  },
  mounted () {
    $(document).ready(function () {
      var sizeLi = $('#myList li').length
      var x = 1
      $('#myList li:lt(' + x + ')').show()
      $('#loadMore').click(function () {
        x = (x + 1 <= sizeLi) ? x + 1 : sizeLi
        $('#myList li:lt(' + x + ')').show()
      })
      $('#showLess').click(function () {
        x = (x - 1 < 0) ? 1 : x - 1
        $('#myList li').not(':lt(' + x + ')').hide()
      })
    })
    this.getVideos()
  },
  watch: {
    '$route' (to, from) {
      this.getVideos()
      this.nowUrl = window.location.href
    }
  },
  methods: {
    getVideos () {
      let self = this
      this.$http.get('/getVideoContent/' + self.$route.params.vid)
        .then(function (response) {
          if (response.data && response.data.length) {
            self.videoData = response.data
            if (self.$store.state.userInfo.user_account) {
              self.videoData.player = self.videoData.player + '?cuac=' + self.$store.state.userInfo.user_account + '&token=' + self.$store.state.token.replace('Bearer ', '')
            }
            self.embedCode = '<iframe src="' + self.videoData.player + '" allowfullscreen></iframe>'
            self.getVideosRelated()
          } else {
            self.$router.push({ name: 'Home' })
          }
        })
    },
    getVideosRelated () {
      let self = this
      this.$http.get('/getVideos/related/7/1?cates=' + self.serializeCategoryId(self.videoData.category_list))
        .then(function (response) {
          self.videosRelated = response.data.list
        })
    },
    serializeCategoryId (obj) {
      var str = []
      obj.forEach(function (element) {
        str.push(element.id)
      })
      return str.join(',')
    },
    lineShareJs: function (event) {
      var line = new this.$Line()
      line.share(window.location.href)
    }
  },
  metaInfo () {
    return {
      titleTemplate: this.videoData.title + ' - %s'
    }
  }
}
</script>
